import { ConfigurationSetting } from '@azure/app-configuration';
import AppLogger from '@shared/logging/appLogger';
import axios, { AxiosError } from 'axios';

export default async function (appConfigKey: string): Promise<ConfigurationSetting> {
    return await axios
        .get(`${process.env.AUCTIONS_GATEWAY_BASEURL}config/kv/${appConfigKey}`, {
            headers: {
                'cache-control': 'must-revalidate',
            },
        })
        .then(res => res.data)
        .catch((err: AxiosError) => {
            AppLogger.logException({ error: err });
            throw err;
        });
}
